import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import FusePageSimple from "@fuse/core/FusePageSimple";
import DemoContent from "@fuse/core/DemoContent";

const Root = styled(FusePageSimple)(({ theme }) => ({
  "& .FusePageSimple-header": {
    backgroundColor: theme.palette.background.paper,
    borderBottomWidth: 1,
    borderStyle: "solid",
    borderColor: theme.palette.divider,
  },
  "& .FusePageSimple-toolbar": {},
  "& .FusePageSimple-content": {},
  "& .FusePageSimple-sidebarHeader": {},
  "& .FusePageSimple-sidebarContent": {},
}));

function ExamplePage(props) {
  const { t } = useTranslation("examplePage");

  return (
    <Root
      header={
        <div className=" m-16 mt-8 text-4xl sm:text-3xl font-extrabold tracking-tight leading-tight">
          {t("TITLE")}
        </div>
      }
      content={
        <div className="p-24">
          {/* <h1 className="pb-12 font-800 m-10">YPMS</h1> */}
          <DemoContent />
        </div>
      }
      scroll="content"
    />
  );
}

export default ExamplePage;
